import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class E2eService {
    correlationReference: string;
    failConditions: any = {};
    $failConditions: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private activatedRoute: ActivatedRoute
    ) {
        this.correlationReference = uuidv4();
        this.init();
    }

    /**
     * @description Attemtps to find any query params that support end to end
     * testing and make them available for use.
     */
    init() {
        // e2e Error support
        this.activatedRoute.queryParams.subscribe(params => {
            if (!params.e2efailon || !params.e2efailwith) {
                return;
            }

            this.failConditions = {
                failOn: params.e2efailon.toLowerCase(),
                failWith: params.e2efailwith
            };
            this.$failConditions.next(this.failConditions);
        });
    }
}
